<template>
<div :style="scaleStyle"
     ref="previewMain"
     :class="{'is-sample': isSample, 'is-preview': !isSample}">
  <section class="sheet">
          <div class="destination1">
              <div class="destination2">
                  <div class="address add">
                      <p class="label"></p>
                      <p class="input">{{ $formLib.separatedPostNumber(formatData.addressData_postNumber) }}<br>{{formatData.addressData_address1}}<br>{{formatData.addressData_address2}}</p>
                      <p class="label company-name">{{formatData.addressData_companyName}}</p>
                  </div>
                  <div class="company">
                      <p class="input company-pic">{{getStaffname}}<span class="company-title"> 様</span></p>
                  </div>
              </div>
          </div>
          <div class="user">
              <div class="postal-code">
                  <p class="input">{{ $formLib.separatedPostNumber(formatData.from_post) }}</p>
              </div>
              <div class="address">
                  <p class="input">{{formatData.from_address1}}<br>{{formatData.from_address2}}</p>
              </div>
              <div class="name">
                  <p class="input">{{formatData.from_name}}</p>
              </div>
          </div>
        </section>
</div>

</template>

<style lang="scss" scoped>

@page {
    size:240mm 332mm;
}

@media print {
  body {
    width: 240mm; /* needed for Chrome */
    }
}

@media screen { /* プレビュー用のスタイル */
    body {
        background: #eee;
    }
    .sheet {
    box-shadow: 0 .5mm 2mm rgba(0,0,0,.3); /* ドロップシャドウ */
    margin: 5mm;
}
}

p.input{
    margin: 0;
}

.sheet {
    position: relative;
    width: 240mm;
    height: 332mm; /* 1mm余裕をもたせる */
    page-break-after: always;
    padding: 50px;
    font-size: 180%;
}

.destination1{
    padding: 60px 0 0 120px;
}

.destination1 .postal-code{
    text-align: right;
    padding-right: 25px;
    margin-bottom: 80px;
}

.destination2{
    width: 100%;
}

.company{
    display: block;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    white-space: nowrap;
    font-size: 130%;
}

.add{
    font-size: 120%;
}

.company-name{
    font-size: 130%;
}

.company-pic{
    white-space: nowrap;
}

.company-title{
    padding-top: 20px;
}

.user{
    position: absolute;
    bottom: 50px;
    font-size: 80%;
    width: 70%;
    left: 10%;
}

</style>

<script>
import LetterPreviewMixin from '@/mixins/letter-preview-mixin'
export default {
  name: 'labelPreview',
  mixins: [LetterPreviewMixin],
  data: function () {
    return {
      staffname: this.formatData.addressData_staffName?this.formatData.addressData_staffName:'ご担当者'
    }
  },
  computed: {
    getStaffname: function () {
      if (!this.formatData.addressData_staffName) {
        return 'ご担当者'
      } else {
        return this.formatData.addressData_staffName
      }
    }
  },
  watch: {
    'formatData.addressData_staffName': function (newValue, oldValue) {
      console.error('formatData.addressData_staffName')
      if (!this.formatData.addressData_staffName) {
        this.staffname = 'ご担当者'
      } else {
        this.staffname = this.formatData.addressData_staffName
      }
    },
  },
  methods: {
    checkValid: function () {
    }
  }
}
</script>
